import layoutdebugicon from "../../../../assets/images/docs/layoutdebugicon.png";
import * as React from 'react';
export default {
  layoutdebugicon,
  React
};